/**
 * @param storeState
 * @returns {CreateNotificationPayload[] | []}
 */
export const getGenericNotifications = (storeState) => storeState.notifications.generic;
